import { Component } from '@theme/component';

class SwatchSelect extends Component {
  #clickOutsideHandler = (event) => {
    if (!this.contains(event.target)) this.close();
  };

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('pointerdown', this.#clickOutsideHandler);
  }

  toggle() {
    /** @type {HTMLElement} */ (this.refs.panel)?.hasAttribute('hidden') ? this.open() : this.close();
  }

  open() {
    const panel = /** @type {HTMLElement} */ (this.refs.panel);
    const trigger = /** @type {HTMLElement} */ (this.refs.trigger);
    if (!panel || !trigger) return;
    panel.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('pointerdown', this.#clickOutsideHandler);
  }

  close() {
    const panel = /** @type {HTMLElement} */ (this.refs.panel);
    const trigger = /** @type {HTMLElement} */ (this.refs.trigger);
    if (!panel || !trigger) return;
    panel.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', this.#clickOutsideHandler);
  }

  selectOption(optionValueId) {
    const nativeSelect = /** @type {HTMLSelectElement} */ (this.refs.nativeSelect);
    if (!nativeSelect) return;
    const option = nativeSelect.querySelector(`option[data-option-value-id="${optionValueId}"]`);
    if (!option) return;
    nativeSelect.value = option.value;
    nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    this.close();
  }

  handleKeydown(event) {
    if (!(event instanceof KeyboardEvent)) return;
    if (event.key === 'Escape') {
      this.close();
      /** @type {HTMLElement} */ (this.refs.trigger)?.focus();
    }
  }
}

if (!customElements.get('swatch-select')) {
  customElements.define('swatch-select', SwatchSelect);
}
